import { Mesh, MeshStandardMaterial, PlaneGeometry } from 'three';

import type { GeometryBuilder } from '../geometry-builder.class';

/**
 * Create a floor/carpet mesh
 */
export const createFloorCfn = (
	self: GeometryBuilder,
	{ material, size = 1000 }: { material: MeshStandardMaterial; size?: number }
): Mesh => {
	const geometry = new PlaneGeometry(size, size, 1, 1);
	const floor = new Mesh(geometry, material);

	floor.rotation.x = -Math.PI / 2; // Rotate to be horizontal
	floor.position.y = -0.01; // Slightly below 0 to prevent z-fighting

	const enableShadows = self.configAccess.qualitySettings?.shadowMapEnabled ?? true;
	floor.castShadow = false;
	floor.receiveShadow = enableShadows;

	floor.userData = {
		id: 'floor',
		type: 'floor'
	};

	return floor;
};
